import { Component, inject, OnInit, signal } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { ButtonComponent, CardComponent, IconComponent } from '@webapp/ui';
import { IIssuedPolicyResponse } from '@webapp/payments';
import { QuoterService } from '../../../services/quoter.service';
import { firstValueFrom } from 'rxjs';
import { ShowForChannelDirective } from '@webapp/core/directives/showForChannel';
import { QUOTER_ROUTE_PATH } from '@webapp/core';
import { QuoterStoreService } from '@webapp/quoter/store/quoter-store.service';
import { RiskRegistry } from '@webapp/risk-core';

@Component({
  selector: 'app-quoter-success',
  imports: [
    CardComponent,
    ButtonComponent,
    RouterLink,
    IconComponent,
    ShowForChannelDirective,
  ],
  templateUrl: './quoter-success.component.html',
  styleUrl: './quoter-success.component.scss',
})
export class QuoterSuccessComponent implements OnInit {
  quoterRoutePath = QUOTER_ROUTE_PATH;

  private router = inject(Router);
  private quoterService = inject(QuoterService);
  quoterStoreService = inject(QuoterStoreService);
  private riskRegistry = inject(RiskRegistry);
  loading = signal<boolean>(false);
  policyResponse!: IIssuedPolicyResponse;
  ngOnInit(): void {
    this.policyResponse = JSON.parse(localStorage.getItem('activar_policy') ?? '');
  }

  viewDetail(policyId: string) {
    this.router.navigate(['polizas', policyId]);
  }

  isVehicle() {
    const risk = JSON.parse(localStorage.getItem('activar_risk') ?? '');
    return this.riskRegistry.find(risk.tag)?.capabilities.vehicle ?? false;
  }
  showName(type: string){
    if(this.isVehicle()){
      return type;
    }else{
      return '';
    }
  }
  async downloadCertificate() {
    this.loading.set(true);
    const blob = await firstValueFrom(
      this.quoterService.downloadCertificate(this.policyResponse.policies[0].id)
    );

    this.loading.set(false);

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `poliza_${this.policyResponse.policies[0].id}.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);

    //window.location.href = this.policy.linkPDF;
  }
}
